import React from 'react';

import { AboutUs, Chef, FindUs, Footer, Gallery, Header, Intro, SpecialMenu } from './container';
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    {/*<FindUs />*/}
    <Gallery />
    <SpecialMenu />
    <AboutUs />
    <Chef />
    {/*<Intro />*/}
    <Footer />
  </div>
);

export default App;
